import {evaluate} from 'mathjs'
function prepareTreeMetaData(treeConfig, extraFieldsToDestructure=[],needToDelete=[]) {
    let treeMetaData = []
    const prepareTreeMetaDataHelper = (tc) => {
        needToDelete.forEach(key=>{
            delete tc[key]
        })
        if (tc['children'].length) {
            let i = 0
            while (i < tc.children.length) {
                prepareTreeMetaDataHelper(tc.children[i])
                i++;
            }
            //after all children are done, put the current tc data
            let { calcType, id, tagId, tsTable, aggregateWindow, aggregateWindowUnit, windowSize, customFormulaData, tag, ...extraFieldsToDestructure} = tc
            treeMetaData.push({ calcType, id, tagId, tsTable, aggregateWindow, aggregateWindowUnit, windowSize, customFormulaData, raw:tag?.calculated?0:1,tag, ...extraFieldsToDestructure})
        } else {
            let { calcType, id, tagId, tsTable, aggregateWindow, aggregateWindowUnit, windowSize, customFormulaData, tag, ...extraFieldsToDestructure} = tc
            treeMetaData.push({ calcType, id, tagId, tsTable, aggregateWindow, aggregateWindowUnit, windowSize, customFormulaData, raw:tag?.calculated?0:1,tag, ...extraFieldsToDestructure})
        }
        //if children is there, run a loop and recursively scan each children

    }

    if(treeConfig)
        prepareTreeMetaDataHelper(treeConfig)
    //finally return the values
    return treeMetaData
}

function fillMyAttributes(tc, myRow, startColNum, attributesMap){
    let attrCounter = 1
    for(let i = startColNum; i < myRow.length; i++){
        if(attrCounter <= Object.keys(attributesMap).length) tc[attributesMap[attrCounter]] = myRow[i]
        if(myRow[i]){
            attrCounter++; //we have found value for the first attr, hence move to next attr
        }
    }
}

function hasChildren(excelData, rowNum, colNum){
    //a node has children, if bottom cell is empty && for non root node bottom left cell also has to be empty
    if(excelData[rowNum][colNum+1]) {
       return true
    }
    return false
}
function convertExcelToTreeConfig(excelData){
    //excelData is a 2d list
    const attributesMap = {1: 'sheetName', 2: 'cellAddress'} //1st attribute of node is sheetName, 2nd is cellAdress etc

    const recurseColumnWise  = (row, col, tc, parentId, myIndex, level) => {
        tc.title = excelData[row][col]
        tc.level = level
        if(!tc.children) tc.children = []
        //tc.add other attributes also
        fillMyAttributes(tc, excelData[row], col+1, attributesMap)
        console.log("Row", row, tc)
        if(col == 0){
            //i.e root node
            tc.id = "0"
        }else{
            tc.id = `${parentId}.${myIndex}` //i am the (currentChildrenCountOfMyParent)th child
        }
        while(row < excelData.length-1){//bottom is empty, that means we have some child
            row++ //go one row down one by one in loop
            if(hasChildren(excelData, row, col)){
                tc.children.push(recurseColumnWise(row, col+1, {}, tc.id, tc.children.length, level+1))
            }
            else if(!excelData[row][col] && (col == 0 || (col > 0 && !excelData[row][col-1]))){
                //That means intermediary row
                //if empty row below. and bottom-left is also empty. Because for the last leaf node of a parent, bottom is empty but bottom left is non empty
                //But for a intermediate parent, if bottom row is empty, and it has children too, bottom-left is empty
                continue
            }
            else{
                console.log(`[${tc.title}] Me returning control back. I control row ${row} col ${col} now`);
                return tc
            }

        }
        console.log(`[${tc.title}] Me returning control back`);
        return tc
    }

    let treeConfig = recurseColumnWise(0, 0, {}, "", null, 0)
    return treeConfig

}

function evaluateCustomFormulaNodes(treeConfig, treeNodeIdToVal){
    //formula = A+B/C
    //childrenUsedInFormula = [{id: 0.0, tagId....etc}, {id: 0.1, tagId....}, {id: 0.3, tagId....}]
    //A = 0.0 node, B = 0.1 node, C = 0.3 node
    let treeNodeIdToValTemp = {...treeNodeIdToVal}
    const evaluateCustomFormulaNodesHelper = (tc) => {
            if (!tc['children'].length) {
                return 0
            }
        if (tc['calcType'] == 4 && tc['useChildrenVal'] && tc['children'].length) {
            let i = 0
            let customFormulaData = tc['customFormulaData']
            let formula = customFormulaData.formula, childrenUsedInFormula = customFormulaData.tags, childrenUsedInFormulaToVal = {}
            childrenUsedInFormula.forEach(c => childrenUsedInFormulaToVal[c.id] = '')
            while (i < tc.children.length) {
                let ithChild = tc.children[i]
                //for each children, if children also has calcType = 4, recurse that children again
                if(ithChild.calcType == 4 && ithChild.useChildrenVal){
                    let ithChildVal = evaluateCustomFormulaNodesHelper(ithChild)
                    //put this value in the formula by replacing the correct variable in the formula
                    let childIdx = childrenUsedInFormula.findIndex(c => c.id === ithChild.id)
                    let variableName = String.fromCharCode(65+childIdx)
                    formula = formula.replaceAll(variableName, ithChildVal)
                }
                else{
                    //only if this child is a part of parent's formula, then only conside this
                    if(childrenUsedInFormulaToVal.hasOwnProperty(ithChild.id)){
                       let ithChildVal = treeNodeIdToVal[ithChild.id]
                       //put this value in the formula by replacing the correct variable in the formula
                       let childIdx = childrenUsedInFormula.findIndex(c => c.id === ithChild.id)
                       let variableName = String.fromCharCode(65+childIdx)
                       formula = formula.replaceAll(variableName, ithChildVal)
                    }
                    evaluateCustomFormulaNodesHelper(ithChild)
                }
                i++;
            }
            try{
                let myValueCalculatedFromChildren = evaluate(formula), myId = tc.id
                treeNodeIdToValTemp[myId]  = myValueCalculatedFromChildren
                return myValueCalculatedFromChildren
            }catch{
                let myId = tc.id
                treeNodeIdToValTemp[myId] = ""
                return 0
            }

            //after all children are done, put the current tc data
        }
        else{
            for (let child of tc.children){
                evaluateCustomFormulaNodesHelper(child)
           }
        }
    }
    if(treeConfig?.length)
        evaluateCustomFormulaNodesHelper(treeConfig[0])
    return treeNodeIdToValTemp
}

function arrayToTree(array) {
    const root = { ...array[0]}; // Create the root node
    const stack = [root]; // Initialize a stack with the root node

    // Iterate through the array and create nodes as needed
    for (let i = 1; i < array.length; i++) {
      const node = { ...array[i]};
      const parent = stack[stack.length - 1];
      if (parent.children?.length === 2) {
        stack.pop();
      }
      stack.push(node);
    }

    return root;
  }
  function treeToArray(node) {
    const result = []; // Initialize an empty array

    // Recursively add each node to the array
    function traverse(node) {
      result.push(node);
      for (let i = 0; i < node?.children?.length; i++) {
        traverse(node.children[i]);
      }
    }

    traverse(node); // Call the traverse function to add nodes to the array
    return result;
  }

export {prepareTreeMetaData, evaluateCustomFormulaNodes, convertExcelToTreeConfig, treeToArray, arrayToTree}